<template>
  <div>
    <portal to="toolbar-title">
      <wnl-text>Ανυψωτικά</wnl-text>
    </portal>
    <single-page hide-sidebar>
      <template v-slot:toolbar-title>
        Eπιλέξτε
        <wnl-text>Ανυψωτικό</wnl-text>
      </template>
      <template v-slot:main-content>
        <v-card>
          <project-list max-height="100%"></project-list>
        </v-card>
      </template>
    </single-page>
  </div>
</template>

<script>
import ProjectList from "@/views/Projects/components/ProjectList";
import SinglePage from "@/components/templates/SinglePage";
import WnlText from "@/wl-unit-text/WnlText";
import {mapGetters} from "vuex";

export default {
  name: "Projects",
  components: {WnlText, SinglePage, ProjectList},

  computed: {
    ...mapGetters([
      'projects'
    ])
  }
}
</script>

<style scoped>

</style>
